/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MdmIngestExecutionDto } from './MdmIngestExecutionDto';
import {
    MdmIngestExecutionDtoFromJSON,
    MdmIngestExecutionDtoFromJSONTyped,
    MdmIngestExecutionDtoToJSON,
    MdmIngestExecutionDtoToJSONTyped,
} from './MdmIngestExecutionDto';
import type { ShardPressureDto } from './ShardPressureDto';
import {
    ShardPressureDtoFromJSON,
    ShardPressureDtoFromJSONTyped,
    ShardPressureDtoToJSON,
    ShardPressureDtoToJSONTyped,
} from './ShardPressureDto';

/**
 * 
 * @export
 * @interface IngestScaleSnapshotDto
 */
export interface IngestScaleSnapshotDto {
    /**
     * 
     * @type {number}
     * @memberof IngestScaleSnapshotDto
     */
    shardCount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IngestScaleSnapshotDto
     */
    taskQueuesSharded?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IngestScaleSnapshotDto
     */
    baseTaskQueue?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IngestScaleSnapshotDto
     */
    admissionEnabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof IngestScaleSnapshotDto
     */
    maxRunningPerShard?: number;
    /**
     * 
     * @type {number}
     * @memberof IngestScaleSnapshotDto
     */
    totalRunningExecutions?: number;
    /**
     * 
     * @type {Array<ShardPressureDto>}
     * @memberof IngestScaleSnapshotDto
     */
    shards?: Array<ShardPressureDto>;
    /**
     * 
     * @type {MdmIngestExecutionDto}
     * @memberof IngestScaleSnapshotDto
     */
    mdmIngestExecution?: MdmIngestExecutionDto;
}

/**
 * Check if a given object implements the IngestScaleSnapshotDto interface.
 */
export function instanceOfIngestScaleSnapshotDto(value: object): value is IngestScaleSnapshotDto {
    return true;
}

export function IngestScaleSnapshotDtoFromJSON(json: any): IngestScaleSnapshotDto {
    return IngestScaleSnapshotDtoFromJSONTyped(json, false);
}

export function IngestScaleSnapshotDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IngestScaleSnapshotDto {
    if (json == null) {
        return json;
    }
    return {
        
        'shardCount': json['shardCount'] == null ? undefined : json['shardCount'],
        'taskQueuesSharded': json['taskQueuesSharded'] == null ? undefined : json['taskQueuesSharded'],
        'baseTaskQueue': json['baseTaskQueue'] == null ? undefined : json['baseTaskQueue'],
        'admissionEnabled': json['admissionEnabled'] == null ? undefined : json['admissionEnabled'],
        'maxRunningPerShard': json['maxRunningPerShard'] == null ? undefined : json['maxRunningPerShard'],
        'totalRunningExecutions': json['totalRunningExecutions'] == null ? undefined : json['totalRunningExecutions'],
        'shards': json['shards'] == null ? undefined : ((json['shards'] as Array<any>).map(ShardPressureDtoFromJSON)),
        'mdmIngestExecution': json['mdmIngestExecution'] == null ? undefined : MdmIngestExecutionDtoFromJSON(json['mdmIngestExecution']),
    };
}

export function IngestScaleSnapshotDtoToJSON(json: any): IngestScaleSnapshotDto {
    return IngestScaleSnapshotDtoToJSONTyped(json, false);
}

export function IngestScaleSnapshotDtoToJSONTyped(value?: IngestScaleSnapshotDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'shardCount': value['shardCount'],
        'taskQueuesSharded': value['taskQueuesSharded'],
        'baseTaskQueue': value['baseTaskQueue'],
        'admissionEnabled': value['admissionEnabled'],
        'maxRunningPerShard': value['maxRunningPerShard'],
        'totalRunningExecutions': value['totalRunningExecutions'],
        'shards': value['shards'] == null ? undefined : ((value['shards'] as Array<any>).map(ShardPressureDtoToJSON)),
        'mdmIngestExecution': MdmIngestExecutionDtoToJSON(value['mdmIngestExecution']),
    };
}

